import PropTypes from "prop-types";
import { LuX, LuInfo } from "react-icons/lu";

export default function EmptyEstadoModal({ onClose, estado }) {
  return (
    <div
      className="fixed inset-0 z-50 overflow-y-auto bg-black/50 backdrop-blur-sm"
      aria-labelledby="empty-estado-modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-center justify-center min-h-screen px-4 text-center">
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
          &#8203;
        </span>

        <div className="relative inline-block w-full max-w-md p-7 overflow-hidden text-left align-middle transition-all transform bg-white border-2 shadow-xl outline-none sm:my-8 rounded-2xl border-[#FCAE52]">

          {/* Header */}
          <div className="flex items-start justify-between mb-5">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-[3px] border-[#FCAE52]">
                <LuInfo className="text-[#FCAE52]" size={20} />
              </div>
              <div>
                <p id="empty-estado-modal-title" className="text-lg font-semibold text-gray-800">
                  Sin siniestros para este estado
                </p>
                {estado && (
                  <p className="text-sm text-gray-500">
                    Estado: {estado}
                  </p>
                )}
              </div>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="flex items-center justify-center p-1.5 text-gray-400 transition-colors duration-200 bg-transparent rounded-full hover:bg-gray-100"
              aria-label="Cerrar modal"
            >
              <LuX size={22} />
            </button>
          </div>

          {/* Body */}
          <div className="mb-5">
            <p className="text-sm text-gray-600">
              Actualmente no hay ningún siniestro con el estado{" "}
              <span className="font-semibold">{estado}</span>.
            </p>
          </div>

          {/* Footer */}
          <div className="flex justify-end pt-2">
            <button
              type="button"
              onClick={onClose}
              className="h-10 px-5 text-sm font-semibold text-white transition-colors duration-150 bg-[#FCAE52] border border-[#FCAE52] rounded-xl hover:bg-[#e99d3f]"
            >
              Entendido
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}

EmptyEstadoModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  estado: PropTypes.string,
};
